export default __webpack_public_path__ + "static/media/RAPPORT GENERAL ANNUEL DES ACTIVITES 2023.4f15c28d.pdf";